import { Component, Input } from "@angular/core";

import { InsaCronService } from "../../../../insa-services";

@Component({
    selector: "delete-activity",
    template: require("./delete-activity.component.html"),
})

export class DeleteActivitiesComponent {

    @Input() activityData: any;

    deleteActivity: any;

    private submitted: boolean = false;

    constructor(private _insaChronosService: InsaCronService) { }

    onSubmit(deletedActivity: any) {
        this.submitted = true;
        // stop here if form is invalid
        if (deletedActivity.invalid) {
            return;
        }
        this.deleteActivity = deletedActivity;
    }
}


// WEBPACK FOOTER //
// ./app/insa-components/insa-cron/insa-job/insa-job-activities-form/delete-activity.component.ts